import { API, APIParams, APIPath, APIResponse } from 'common/api/schema'
import { authedApiCall, formatApiUrlWithParams } from 'common/util/api'
export { APIError } from 'common/api/utils'

export type apiWithoutAuth<P extends APIPath> = (
  path: P,
  params: APIParams<P>
) => Promise<APIResponse<P>>

/**
 * Call an API endpoint with the current Supabase session token.
 * The token provider must be set via setTokenProvider() during app init.
 */
export async function apiWithAuth<P extends APIPath>(
  path: P,
  params: APIParams<P> = {}
) {
  return authedApiCall(
    formatApiUrlWithParams(path, params),
    API[path].method,
    params
  ) as Promise<APIResponse<P>>
}
